<div class="drop-sm relative w-full sm:w-[300px] mt-1 sm:mt-0">
    <button (click)="toggleDropdown($event)"
      class="w-full flex items-center justify-between bg-white px-4 h-[44px] rounded-md border border-gray-300 text-sm text-[#2f3743] hover:bg-gray-50 transition cursor-pointer"
      type="button" aria-haspopup="listbox" [attr.aria-expanded]="dropdownAberto">
      <div class="flex items-center gap-2">
        <mat-icon *ngIf="icone" class="text-[#2f3743]">{{ icone }}</mat-icon>
        <span class="hidden sm:inline mt-[5px]">
          {{ valorSelecionadoNome || placeholder }}
        </span>
      </div>
      <mat-icon class="text-gray-500 text-sm">
        {{ dropdownAberto ? 'expand_less' : 'expand_more' }}
      </mat-icon>
    </button>
  
    <ul *ngIf="dropdownAberto"
      class="absolute left-0 right-0 mt-1 w-[90vw] sm:w-full border border-gray-200 bg-white rounded-md shadow-md z-50 py-1 max-h-60 overflow-auto"
      role="listbox">
      <li *ngFor="let opcao of opcoes"
          class="px-4 py-2 hover:bg-orange-50 transition cursor-pointer text-[#2f3743]"
          [class.text-gray-400]="opcao.desabilitado"
          [class.cursor-not-allowed]="opcao.desabilitado"
          [class.bg-gray-50]="opcao.desabilitado"
          [attr.aria-selected]="valorSelecionado === opcao.valor"
          [attr.aria-disabled]="opcao.desabilitado"
          (click)="!opcao.desabilitado && selecionarOpcao(opcao)"
          role="option">
        {{ opcao.nome }} {{ opcao.desabilitado ? '(desabilitado)' : '' }}
      </li>
    </ul>
  </div>
  